<template>
    <div class="hero__content" :class="{'hero__content--video' : hero_is_video}">
        <div class="hero__text">
            <p class="member_disclaimer">Offre réservée aux nouveaux membres</p>
            <p class="offer_text">Découvrez Testachats avec notre offre à 2€/2 mois et</p>
            <img class="box_up" :src="box_up_image" alt="gifts">
            <p class="gift_text">choisissez votre cadeau <strong>gratuit</strong></p>
            <div class="offer_pastille">offre <span class="price">2€</span> <span class="time">/2mois</span></div>
            <img class="box_gifts" :src="box_down_image" alt="gifts">
        </div>
    </div>
</template>

<script>
import image_mixin from "../../_commons/fr/mixins/image_mixin";

export default {
    name: "HomeHeroDesktop",
    mixins: [
        image_mixin
    ]
}
</script>

<style scoped>

</style>
